import React from 'react';
import { LOG_FILE_CARD_STRINGS } from '../../pages/SupportAndTroubleshoot/SupportAndTroubleshootStrings';
import { FolderIcon } from '../../Icons/FolderIcon/FolderIcon';
import { DownloadIcon } from '../../Icons/DownloadIcon/DownloadIcon';
import { TrashIcon } from '../../Icons/TrashIcon/TrashIcon';
import { IconButton } from '../../components/Buttons/IconButton/IconButton';
import './LogFileCard.css';

export interface LogFileInfo {
	fileName: string;
	fileSize: string;
	createdAt: string;
}

interface LogFileCardProps {
	logFile: LogFileInfo;
	allowDownloadFile: boolean;
	onDownload: () => void;
	onDelete: () => void;
}

export const LogFileCard: React.FC<LogFileCardProps> = ({
	logFile,
	allowDownloadFile,
	onDownload,
	onDelete,
}) => {
	const displayName = `${logFile.fileName} (${logFile.fileSize})`;

	return (
		<div className="log-file-section">
			<p className="log-file-section-title">{LOG_FILE_CARD_STRINGS.LAST_LOG}</p>
			<div className="log-file-item">
				<div className="log-file-icon">
					<FolderIcon />
				</div>
				<div className="log-file-info">
					<div className="log-file-name" title={displayName}>
						{displayName}
					</div>
					<div className="log-file-date">{logFile.createdAt}</div>
				</div>
				<div className="log-file-actions">
					{allowDownloadFile && (
						<IconButton
							onClick={onDownload}
							ariaLabel={LOG_FILE_CARD_STRINGS.DOWNLOAD_LOG_FILE}
							tooltip={LOG_FILE_CARD_STRINGS.DOWNLOAD}
							showBorder={false}
						>
							<DownloadIcon />
						</IconButton>
					)}
					<IconButton
						onClick={onDelete}
						ariaLabel={LOG_FILE_CARD_STRINGS.DELETE_LOG_FILE}
						tooltip={LOG_FILE_CARD_STRINGS.DELETE}
						variant="delete"
						showBorder={false}
					>
						<TrashIcon />
					</IconButton>
				</div>
			</div>
		</div>
	);
};
